module.exports = __webpack_public_path__ + "img/GDPO_preview.png";